
<ion-modal [isOpen]="isOpen()" (willDismiss)="isOpen.set(false)" id="confirm-modal">
  <ng-template>
    <div id="confirm-container">
      <h4>Voulez-vous vraiment retirer <br><span>{{ content() }}</span> ?</h4>
      <div id="button-container">
        <ion-button (click)="isOpen.set(false)">
          Annuler
        </ion-button>
        <ion-button (click)="validate()">
          Valider
        </ion-button>
      </div>
    </div>
  </ng-template>
</ion-modal>